const TRACKING_LIST_STALE_KEY = 'contrak:trackingContainersStale';

/** Vessel ETA changed on Order while the tracking list query is not mounted */
export function markTrackingContainersStale(): void {
  try {
    sessionStorage.setItem(TRACKING_LIST_STALE_KEY, '1');
  } catch {
    // ignore private mode / blocked storage
  }
}

export function consumeTrackingContainersStale(): boolean {
  try {
    if (sessionStorage.getItem(TRACKING_LIST_STALE_KEY) !== '1') {
      return false;
    }
    sessionStorage.removeItem(TRACKING_LIST_STALE_KEY);
    return true;
  } catch {
    return false;
  }
}
